import { render, staticRenderFns } from "./dv-modal.vue?vue&type=template&id=653ec4f5"
import script from "./dv-modal.vue?vue&type=script&lang=js"
export * from "./dv-modal.vue?vue&type=script&lang=js"
import style0 from "./dv-modal.vue?vue&type=style&index=0&id=653ec4f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports